export default __webpack_public_path__ + "static/media/signup.67ab2f55.jpg";